import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { verifyRazorpayPayment } from '../../../api/ordersApi';
import { ApiError } from '../../../api/client';
import { useCart } from '../../../context/CartContext';
import { readStoredAuth } from '../profileFormUtils';
import { clearStoredAppliedCoupon } from '../../Cart/cartCouponStorage';
import { clearStoredCheckoutPayload } from './paymentCheckoutState';
import {
  clearStoredPendingOrderPayment,
  resolvePendingOrderPayment,
} from './pendingOrderPaymentState';
import { parseRazorpayReturnSearch } from './razorpayReturnUtils';
import './PaymentOutcome.css';

const PaymentReturn = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const { clearCart } = useCart();
  const { token } = readStoredAuth();
  const [error, setError] = useState('');
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;

    const parsed = parseRazorpayReturnSearch(search);
    if (!parsed) {
      setError('Payment details were missing. You can retry from My Orders.');
      return;
    }

    const pending = resolvePendingOrderPayment();
    const grandTotal = pending?.charges?.grandTotal ?? pending?.grandTotal;

    (async () => {
      try {
        await verifyRazorpayPayment({
          token: token || '',
          orderNumber: parsed.orderNumber,
          rzpOrderID: parsed.rzpOrderID,
          rzpPaymentId: parsed.rzpPaymentId,
          razorpaySignature: parsed.razorpaySignature,
        });

        clearCart();
        clearStoredCheckoutPayload();
        clearStoredAppliedCoupon();
        clearStoredPendingOrderPayment();

        navigate('/payment/success', {
          replace: true,
          state: {
            orderNumber: parsed.orderNumber,
            grandTotal,
          },
        });
      } catch (err) {
        const message =
          err instanceof ApiError
            ? err.message
            : err instanceof Error
              ? err.message
              : 'Payment could not be verified. Please try again from My Orders.';
        setError(message);
      }
    })();
  }, [search, token, navigate, clearCart]);

  if (error) {
    return (
      <div className="payment-outcome-page">
        <div className="payment-outcome-card">
          <h1>Payment not completed</h1>
          <p className="payment-outcome-card__meta">{error}</p>
          <div className="payment-outcome-card__actions">
            <Link to="/account/orders" className="btn-primary">
              My Orders
            </Link>
            <Link to="/payment" className="payment-outcome-card__link">
              Back to payment
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="payment-outcome-page">
      <div className="payment-outcome-card">
        <h1>Completing your payment…</h1>
        <p className="payment-outcome-card__meta">Please wait while we confirm with Razorpay.</p>
      </div>
    </div>
  );
};

export default PaymentReturn;
